export default {
  meta: {
    title: '推场管理'
  }
};
